// @flow

const formatCurrency = (amount?: ?number, division?: number = 100): any => {
    return !isNaN(Number(amount))
        ? new Intl.NumberFormat(`en-AU`, {
              currency: `AUD`,
              style: "currency",
          }).format(Number(amount) / division)
        : amount;
};

export default formatCurrency;
